import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Replace the condition below with your actual authentication logic
  const isAuthenticated = localStorage.getItem('isAuthenticated'); // For example, check if user is logged in

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/auth/login" replace />;
  }

  // Allow access to the child route if authenticated
  return children;
};

export default ProtectedRoute;
